import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const saveDefaultFilter = async ({ id, value, type = 'save' }) => {
  const errorText = {
    save: 'Не удалось сохранить фильтр',
    unsave: 'Не удалось убрать фильтр из сохраненных',
  };

  await request.put(
    '/Filter/default',
    {
      id,
      value,
    },
    errorText[type]
  );
};

export const useSaveDefaultFilter = (options) =>
  useMutation(
    ({ id, value, type }) => saveDefaultFilter({ id, value, type }),
    options
  );
